export const copyToClipboard = async (text: string): Promise<{ isError: boolean }> => {
  try {
    await navigator.clipboard.writeText(text);

    return {
      isError: false,
    };
  } catch {
    return {
      isError: true,
    };
  }
};
